module.exports = __webpack_public_path__ + "static/media/logo.d7e87c21.png";